import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import type { EducationSearchItem } from '../../../../Search/Education/Service/EducationSearchItem.csharp';
import { EducationSearchItemType } from '../../../../Search/Education/Service/EducationSearchItemType.csharp';
import { Link } from '~/Partials/Link/Link';
import type { IconName } from '~/Partials/SvgIcon/SvgIcon';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import { assertNever } from '~/Partials/Utils/typeUtils';
import styles from './StudyListSearchResultItem.module.css';

export interface StudyListSearchResultProps {
    value: EducationSearchItem;
}

interface StudyListSearchResultInfo {
    icon: IconName;
    label: string;
}

export const StudyListSearchResultItem = (props: StudyListSearchResultProps) => {
    const {
        value: { linkUrl, levelLabel, locations, name, type, studyFormTypes },
    } = props;

    const getIconName = (itemType: EducationSearchItemType) => {
        switch (itemType) {
            case EducationSearchItemType.CampusStudy:
            case EducationSearchItemType.CampusSubject:
                return 'map-pin';
            case EducationSearchItemType.OnlineStudy:
            case EducationSearchItemType.OnlineSubject:
                return 'globe';
            default:
                assertNever(itemType);
        }
    };

    const icons: StudyListSearchResultInfo[] = [
        { icon: getIconName(type), label: locations.join(' \\ ') },
        { icon: 'book', label: levelLabel },
        { icon: 'activity', label: studyFormTypes.join(' \\ ') },
    ];

    const renderIconWithLabel = (info: StudyListSearchResultInfo) => (
        <div className={styles.Info} key={uniqueId('StudyListSearchResultItem__')}>
            <SvgIcon className={styles.InfoIcon} iconName={info.icon} />
            <span>{info.label}</span>
        </div>
    );

    return (
        <div className={styles.StudyListSearchResultItem} key={linkUrl}>
            <h3 className={styles.Heading}>
                <Link className={styles.HeadingLink} href={linkUrl} label={name} />
            </h3>
            {icons.map(renderIconWithLabel)}
        </div>
    );
};
